<template>
  <div>
    <profile-stats></profile-stats>
    <div v-if="userDetails.gamesPlayed === 0">
      <section class="profile__block">
        <div class="profile__block__header">
          <h2>{{ getTranslations.home_profile_default_content_your_performance }}</h2>
        </div>
        <div class="profile__block__content profile__block__content--empty-state">
          <img :src="getTranslations.project_home_empty_img" alt="">
          <h1>{{ getTranslations.home_profile_default_content_no_performance_data_yet }}</h1>
          <p>{{ getTranslations.home_profile_default_content_play_a_game_now }}</p>
          <div @click.prevent="playMethod" style="cursor:pointer"><a class="btn btn--medium btn--main">{{ getTranslations.home_home_new_game }}</a></div>
        </div>
      </section>
    </div>
    <div v-else>
      <section class="profile__block">
        <div class="profile__block__header">
          <h2>{{ getTranslations.home_profile_default_content_your_performance }}</h2>
        </div>
        <div class="profile__block__content profile__block__content--your-performance">
          <!--<div class="avatar-cont">-->
          <!--<img :src="userDetails.avatar" alt="">-->
          <!--</div>-->
          <div class="stats-cont">
            <div class="stats-cont__item">
              <h4>{{ getTranslations.home_profile_profile_games }}</h4>
              <div class="progressbar">
                <div id="gamesWon" class="progressbar__bar"></div>
              </div>
              <p>{{ gamesWonPercentRatio }}% ({{ numberFormatting(userDetails.gamesWon)
                }}/{{ numberFormatting(userDetails.gamesPlayed)
                }}){{ getTranslations.home_profile_default_content_games_won }}</p>
            </div>
            <div class="stats-cont__item">
              <h4>{{ getTranslations.home_profile_default_content_answers }}</h4>
              <div class="progressbar">
                <div id="correctAnswers" class="progressbar__bar"></div>
              </div>
              <p>{{ correctAnswersPercentRatio }}% ({{ numberFormatting(userDetails.correctAnswersGiven)
                }}/{{ numberFormatting(userDetails.answersGiven)
                }}){{ getTranslations.home_profile_default_content_correct_answers
                }}</p>
            </div>
          </div>
        </div>
      </section>
     <!-- <section class="profile__block">
        <div class="profile__block__header">
          <h2>{{ getTranslations.home_profile_default_content_theme_performance }}</h2>
        </div>
        <div class="profile__block__content profile__block__content--theme-performance">
          <div class="theme-cont generic-carousel theme-carousel">
            <div v-for="(theme, index) in orderedThemes" :key="index" class="theme-cont__icon">
              <img :src="theme.iconUrl" alt="">
              <span style="color:#ffffff">{{theme.score}}%</span>
            </div>
          </div>
          <div class="carousel__nav"></div>
        </div>
      </section> -->
    </div>
  </div>
</template>


<script>

  /* eslint no-param-reassign: ["error", { "props": false }], no-console: "off" */
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import 'owl.carousel';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import ResumeGame from '@/components/home/modals/ResumeGame';
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';
import { updateProgressBarGamesWon, updateProgressBarAnswersPercent } from '@/common/jQuery';
import ProfileStats from './ProfileStats';

export default {
  name: 'profile-default-content',
  mixins: [NumbersFormattingMixin],
  components: {
    ProfileStats,
  },
  data() {
    return {
      themes: [],
      showedModal: false,
    };
  },
  mounted() {
    this.renderProgressBar();
  },
  updated() {
    this.renderProgressBar();
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'getUserThemesStats',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          if (!this.showedModal) {
            console.log("----------------------- Correct DefaultContentProfile For  Store hideModal");
            this.showedModal = true;
            this.storeModalForHomePage(null);
          } else {
            this.storeModalForHomePage(null);
          }
        });
      });
      /* eslint-enable */
    },
    playMethod() {
      console.log('showing resume game pop up in DefaultContentProfile Page...');
      this.checkIfGameToResumeExists().then(() => {
        console.log('this.gameInProgress:', this.gameInProgress);
        if (this.gameInProgress) {
          console.log('showing resume game pop up...');
          this.storeModalForHomePage(ResumeGame);
        } else if (this.userDetails.availableGames === 0 && !this.userDetails.subscribed) {
          if (this.subAndUnsubViaSMS) {
            if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
              this.storeModalForHomePage(ResubscribeGameSms);
            } else {
              this.storeModalForHomePage(ResubscribeGame);
            }
          } else {
            this.storeModalForHomePage(ResubscribeGame);
          }
        } else if (this.userDetails.availableGames === 0 && this.userDetails.subscribed) {
          this.storeModalForHomePage(ZeroBalance);
        } else {
          this.$router.push('/searchingOpponent');
          this.storeModalForHomePage(null);
        }
        this.showModal();
      }).catch(error => console.error(error));
    },
    fetchData() {
      /* eslint-disable */
      this.$nextTick(() => {
        $('.theme-carousel').owlCarousel({
          loop: false,
          responsiveClass: true,
          dots: true,
          autoplay: false,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
          navContainer: '.carousel__nav',
          dotsContainer: '.carousel__dots',
          navText: ['<i   class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'],
          responsive: {
            0: {
              items: 4,
              nav: true,
              onInitialized: function() {
                $(".icon-arrow-left").addClass("deactivated");
              },
              onTranslated: function(event){
                $('.icon-arrow-right').removeClass('deactivated');
                $('.icon-arrow-left').removeClass('deactivated');
                if (event.item.index == 0){
                  $(".icon-arrow-left").addClass("deactivated");
                } else {
                  $(".icon-arrow-left").show();
                }
                if (event.item.index == (event.item.count - 4)){
                  $(".icon-arrow-right").addClass("deactivated");
                }
                else {
                  $(".icon-arrow-right").show();
                }
              }
            },
          },
        })
      });
      /* eslint-enable */
    },
    renderProgressBar() {
      // console.clear();
      this.$nextTick(() => {
        updateProgressBarGamesWon(this.gamesWonPercentRatio);
        updateProgressBarAnswersPercent(this.correctAnswersPercentRatio);
      });
    },
    computeScore() {
      this.themes = JSON.parse(JSON.stringify(this.getThemes));
      this.themes.forEach((element) => {
        element.score = Math.round((element.totalCorrectAnswers / element.totalAnswers) * 100);
      });
    },
  },
  computed: {
    ...mapState('game', [
      'gameInProgress',
    ]),
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getThemes',
    ]),
    orderedThemes() {
      this.computeScore();
      // sort games by date ascending
      return this.themes.slice(0).sort((a, b) => b.score - a.score);
    },
    gamesWonPercentRatio() {
      return Math.round((this.userDetails.gamesWon / this.userDetails.gamesPlayed) * 100);
    },
    correctAnswersPercentRatio() {
      return Math.round((this.userDetails.correctAnswersGiven / this.userDetails.answersGiven) * 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/DefaultContentProfile.vue